import React from "react";

/**
 * Pinned bottom bar with the main button. Optional quiet `secondaryAction` ({ label, onClick })
 * and `footnote` below it. Shows a spinner while a request is running.
 */
function ContinueButton({ children = "Continue", onClick, disabled, busy, secondaryAction, footnote }) {
  return (
    <div className="kv-footer">
      <button
        type="button"
        className="kv-btn kv-btn--primary"
        onClick={onClick}
        disabled={disabled || busy}
        aria-busy={busy}
      >
        {busy ? <span className="kv-spinner" aria-hidden="true" /> : null}
        <span>{busy ? "Please wait…" : children}</span>
      </button>

      {secondaryAction ? (
        <button type="button" className="kv-link-btn" onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </button>
      ) : null}

      {footnote ? <p className="kv-footnote">{footnote}</p> : null}
    </div>
  );
}

export default ContinueButton;
